<template>
    <div>
        <ModalFiltroEmpresas name="cadastro" :id="id" :filtros="filtros" />
        <b-modal
            ref="modalCluster"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            scrollable
            id="modal-cadastro-cluster"
            :title="id ? 'Editar cluster' : 'Criar um novo cluster'"
            @shown="openModal"
            @hide="fecharModal"
            >


               
                <el-form v-loading="loadingForm" class="geral-form" ref="formCluster" :model="model" :rules="rules" size="small" label-position="top">
                    <el-form-item label="Nome" prop="nome" required>
                        <el-input v-model="model.nome"></el-input>
                    </el-form-item>
                    <el-form-item label="Descrição" prop="descricao" required>
                        <el-input type="textarea" v-model="model.descricao"></el-input>
                    </el-form-item>
                    <el-form-item label="Tipo de Cluster" prop="tipoDeCluster">
                        <el-radio-group v-model="model.tipoDeCluster">
                            <el-radio :label="1"><b>Estático</b> - Selecionar manualmente as empresas</el-radio>
                            <el-radio :label="2" :disabled="!premiumUser()"><b>Dinâmico</b> - Marcar automaticamente todas as empresas selecionadas com filtro</el-radio>
                        </el-radio-group>

                        <span v-if="!premiumUser()" @click="showModalPremium('show')" class="premium-tag-s" style="line-height: 20px; top: 22px;">
                            <i class="far fa-star"></i>&nbsp;
                            <b>Premium</b>
                        </span>
                    </el-form-item>

                    <!-- SELECIONAR EMPRESAS - ESTÁTICO -->
                    <el-form-item label="Selecionar empresas" v-show="permitirFiltrarEmpresas">
                      <select2-multiple :options="listas.empresas" name="empresasASelect" v-model="model.EmpresasSelecionadas" :url="$urls.EMPRESAS"></select2-multiple>
                    </el-form-item>

                    <b-form-checkbox v-model="model.outliers" v-show="permitirFiltrarEmpresas" style="font-size: small; margin-bottom: 10px;">Incluir Empresas Outliers</b-form-checkbox>
                    
                    <!-- SELECIONAR EMPRESAS (Outliers) - ESTÁTICO -->
                    <el-form-item label="Selecionar empresas outliers" v-show="model.outliers">
                      <select2-multiple v-if="isRerenderOutliers" :disabled="!model.EmpresasSelecionadas" :hasUpdate="true" :options="listarOutliers" name="empresasOutliersSelect" v-model="model.EmpresasOutliersSelecionadas"></select2-multiple>
                    </el-form-item>

                    <!-- FILTRAR EMPRESAS - DINAMICO -->
                    <div v-show="!permitirFiltrarEmpresas">
                        <el-form-item v-show="showFilters == false">
                            <el-button class="w-100" size="small" type="info" @click="showFilters = true" icon="fas fa-filter"> Filtrar Empresas</el-button>
                        </el-form-item>
                        <el-form-item label="" v-show="showFilters == true" class="mb-2 bg-dark text-white rounded-top header-filter">
                            <i class="fas fa-filter"></i> &nbsp; 
                            Filtrar Empresas 
                            <i class="fas fa-times float-right icon-close-filter" @click="showFilters = false" style="cursor:pointer; font-size: 24px;"></i>
                        </el-form-item>
                        <b-collapse v-model="showFilters"  id="filtroEmpresas" class="border-top-0 border border-secondary p-2 mb-2 rounded-bottom" style="background: #e6e6e6;margin-top:-9px !important;">
                            <el-alert
                                v-show="infoFiltros"
                                type="info"
                                description="Configure os campos referente as empresas que deseja adicionar ao cluster"
                                show-icon
                                @close="fecharInfoFiltros">
                            </el-alert>
                            <el-form-item label="Marca">
                                <el-select class="w-100" size="small"  filterable multiple v-model="filtros.marca" name="filtroMarca" placeholder="selecione">
                                    <el-option
                                    v-for="item in listas.marca"
                                        :key="`marca_${item.id}`"
                                        :label="item.label"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Tipo de Estabelecimento">
                                <el-select class="w-100" size="small"  filterable multiple v-model="filtros.tipoDeEstabelecimento" name="filtroTipoDeEstabelecimento" placeholder="selecione">
                                    <el-option
                                    v-for="item in listas.tipoDeEstabelecimento"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Local do Estabelecimento">
                                <el-select class="w-100" size="small"  filterable multiple v-model="filtros.localEstabelecimento" name="filtroLocalEstabelecimento" placeholder="selecione">
                                    <el-option
                                    v-for="item in listas.localEstabelecimento"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="Incluir pesquisa por">
                                <el-checkbox-button v-model="filtros.sGrupo">Grupo</el-checkbox-button>
                                <el-checkbox-button v-model="filtros.sLocalidade">Localidade</el-checkbox-button>


                                <div class="pull-right" v-show="filtrosMensagemTotal">
                                    <div class="box-filtro-info">
                                        O filtro atual trará todas as empresas
                                    </div>
                                </div>

                            </el-form-item>

                            <b-collapse v-model="filtros.sGrupo">
                                <el-form-item label="Código do Grupo">
                                    <el-select class="w-100" size="small"  filterable multiple v-model="filtros.codigoGrupo" placeholder="selecione">
                                        <el-option
                                            v-for="item in listas.grupo"
                                            :key="item.id"
                                            :label="item.label"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </b-collapse>
                            <b-collapse v-model="filtros.sLocalidade">
                                <el-form-item label="Região">
                                    <el-select class="w-100" size="small"  filterable multiple v-model="filtros.regiaoBrasil" name="filtroRegiao" placeholder="selecione">
                                        <el-option
                                            v-for="item in listas.regiao"
                                            :key="item.id"
                                            :label="item.nome"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Estado">
                                    <el-select class="w-100" size="small"  v-loading="loadingEstado" filterable multiple v-model="filtros.codigoEstado" name="filtroEstado" placeholder="selecione">
                                        <el-option
                                            v-for="item in listas.estado"
                                            :key="item.id"
                                            :label="item.sigla"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Cidade">
                                    <el-select :disabled="habilitaDesabilitaCidades"  v-loading="loadingCidade" class="w-100" size="small" filterable multiple v-model="filtros.codigoCidade" name="filtroEstado" placeholder="selecione">
                                        <el-option
                                            v-for="item in listas.cidade"
                                            :key="item.id"
                                            :label="item.nome"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </b-collapse>
                            <div class="text-right">
                                <el-button size="small" icon="el-icon-brush" @click="limparFiltros">Limpar</el-button>

                                <span class="btn-filtros-a">
                                    <el-button type="primary" size="small" icon="el-icon-search" @click="filtrarEmpresas">Filtrar Empresas</el-button>
                                </span>
                            </div>    
                        </b-collapse>
                    </div>

                    <el-form-item :label="model.ativo ? 'Ativo' : 'Inativo'" prop="ativo">
                        <el-switch v-model="model.ativo" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </el-form-item>

                </el-form>
                
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                        <el-button size="small" icon="el-icon-document-add" type="primary" @click="salvar" :loading="loadingForm">Salvar</el-button> 
                    </div>
                </template>
            </b-modal>
    </div>
</template>
<script>
import Select2Multiple from '@/components/shared/Select2Multiple'
import ModalFiltroEmpresas from '@/views/Cluster/modal/ModalFiltroEmpresas'

const model = (data) => {
    if(data) {
        let outliers = false;

        if(data.outliers) {
            outliers = data.outliers
        }else {
            outliers = data.empresasOutliers && data.empresasOutliers.length ? true : false;
        }
        
        return {
            _id: data._id,
            nome: data.nome,
            descricao: data.descricao,
            EmpresasSelecionadas: data.empresas,
            EmpresasOutliersSelecionadas: data.empresasOutliers,
            tipoDeCluster: data.tipoDeCluster,
            empresas: data.empresas,
            empresasOutliers: data.empresasOutliers,
            ativo: data.ativo,
            outliers: outliers
        }
    }
    
    return {
        _id: '',
        nome: '',
        descricao: '',
        EmpresasSelecionadas: [], // objeto empresas
        EmpresasOutliersSelecionadas: [], // objeto empresas outliers
        tipoDeCluster: 1,
        empresas: [], // id empresas
        empresasOutliers: [], // id empresas outliers
        ativo: true,
        outliers: false
    }
}
const filtros = (data) => {
    if(data) {
        const isNotNull = (val, str) => {
            return val !== null && val !== str ? true : false
        }
        const regraCampo = (campo, isString) => {
            return isNotNull(campo) && campo !== "" ? campo.split(/[,;]/).map(isString ? String : Number) : []
        }

        return {
            marca: regraCampo(data.marca),
            tipoDeEstabelecimento: regraCampo(data.tipoDeEstabelecimento),
            localEstabelecimento: regraCampo(data.localEstabelecimento),
            regiaoBrasil: regraCampo(data.regiaoBrasil),
            codigoEstado: regraCampo(data.codigoEstado),
            codigoCidade: regraCampo(data.codigoCidade, true),
            sGrupo: isNotNull(data.codigoGrupo,'') || isNotNull(data.codigoLoja,'') ? true : false,
            sLocalidade: isNotNull(data.regiaoBrasil,'') ? true : false,
            codigoGrupo: regraCampo(data.codigoGrupo, true),
        }
    }
    return {
        marca: [],
        tipoDeEstabelecimento: [],
        localEstabelecimento: [],
        regiaoBrasil: [],
        codigoEstado: [],
        codigoCidade: [],
        sGrupo: false,
        sLocalidade: false,
        codigoGrupo: [],
    }
}
export default {
    name: 'ModalCluster',
    props: {
        id: {
            type: String,
            require: false
        }
    },
    components: {
        Select2Multiple,
        ModalFiltroEmpresas
    },
    data() {
        return {
            model: model(),
            filtros: filtros(),
            loadingForm: false,
            loadingEstado: false,
            loadingCidade: false,
            loadingEmpresas: false,
            showFilters: true,
            infoFiltros: true,
            isRerenderOutliers: false,
            listas: {
                regiao: [],
                estado: [],
                cidade: [],
                empresas: [],
                empresasOutliers: [],
                marca: [],
                tipoDeEstabelecimento: [],
                localEstabelecimento: [],
                grupo: []
            },
            rules: {
                nome: [{ required: true, message: 'Nome é um campo obrigatório!', trigger: 'blur' }],
                descricao: [{ required: true, message: 'Descrição é um campo obrigatório!', trigger: 'blur' }],
			},
            paginacao: {
                pageNumber: 1,
                perPage: 25
            }
        }
    },
    computed: {
        permitirFiltrarEmpresas(){ // verifica tipo de cluster
            return this.model.tipoDeCluster == 1 ? true : false
        },
        habilitaDesabilitaCidades(){ // multiselect de cidades
            return this.filtros.codigoEstado.length ? false : true
        },
        filtrosMensagemTotal() {
            return !Object.values(this.filtros).some(value => value.length);
        },
        listarOutliers() {
            const _this = this;
            const empresas = _this.model.EmpresasSelecionadas;
            const empresasOutliers = _this.model.empresasOutliers;
            const checkOutliers = _this.model.outliers;

            if(!checkOutliers && !empresas.length) {
                return []
            }

            return _this.listas.empresas.map((obj) => {
                let filter = obj.children.filter((child) => empresas.includes(child.id))
                if(filter.length){
                    return {
                        ...obj,
                        children: filter,
                    }
                }
            });
        }
    },
    watch: {
        'filtros.sLocalidade'(isLocalidade) {
            if(isLocalidade && (!this.listas.regiao.length || !this.listas.estado.length)) {
                this.getListasLocalidades()
            }
        },
        async 'filtros.regiaoBrasil'(data) {
            if(data && !data.length) {
                return false;
            }
            const url = (regioes) => {
                if(Array.isArray(regioes) && regioes.length) {
                    return `https://servicodados.ibge.gov.br/api/v1/localidades/regioes/${regioes.join('|')}/estados`
                } else {
                    return  this.$urls.CLUSTER_ESTADOS
                }
            }
            this.loadingEstado = true;
            this.model.codigoEstado = []

            const response = await this.axios.get(url(data));

            if(response.status !== 200) {
                return;
            }

            this.listas.estado = response.data
            this.loadingEstado = false;

        },
        async 'filtros.codigoEstado'(data) {
            if(data && !data.length) {
                return false;
            }
            const url = (estados) => {
                if(Array.isArray(estados) && estados.length) {
                    return `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estados.join('|')}/municipios`
                } else {
                    return  this.$urls.CLUSTER_CIDADES
                }
            }
            this.loadingCidade = false;
            this.model.codigoCidade = []

            const response = await this.axios.get(url(data));

            if(response.status !== 200) {
                return;
            }

            this.listas.cidade = response.data
            this.loadingCidade = false;

        },
        'model.tipoDeCluster'(val) {
            this.model.empresas = []
            this.model.EmpresasSelecionadas = []
        },
        'model.EmpresasSelecionadas'(val) {
            this.isRerenderOutliers = false;
            this.$nextTick(()=> {
                if(this.listarOutliers.length === 1 && this.listarOutliers[0] === undefined) {
                    this.model.EmpresasOutliersSelecionadas = []
                }
                this.isRerenderOutliers = true;
            });
        },
        'model.empresasOutliers'(val) {
            this.model.EmpresasOutliersSelecionadas = val             
        }
    },
    methods: {
        // requests
        async getCluster() {
            this.loadingForm = true;
            
            let response = await this.axios.get(`${this.$urls.CLUSTER_GETONE}?id=${this.id}`);

            this.loadingForm = false;

            if(response.status !== 200) {
                return;
            }
            
            this.model = model(response.data);
            this.filtros = filtros(response.data.filtros);
        },
        async saveCluster() {
            this.loadingForm = true;

            const dadosEnvio = this.model;

            if(dadosEnvio.tipoDeCluster == 2){ // Cluster dinamico
                let formatarFiltros = {} // formata os valores para o padrao do request (string por , 'virgulas' )

                const retornaString = (index, separator) => {
                    return Array.isArray(this.filtros[index]) ? this.filtros[index].join(separator) : this.filtros[index]
                }

                for(let i in this.filtros){
                    if(i == 'regiaoBrasil' || i == 'codigoEstado' || i == 'codigoCidade'){
                        formatarFiltros[i] = retornaString(i, ';')
                    }else{
                        formatarFiltros[i] = retornaString(i, ',')
                    }
                }

                dadosEnvio.filtros = formatarFiltros
            }

            if(dadosEnvio.EmpresasSelecionadas.length){
                dadosEnvio.Empresas = dadosEnvio.EmpresasSelecionadas
            }
            if(dadosEnvio.EmpresasOutliersSelecionadas != undefined && dadosEnvio.EmpresasOutliersSelecionadas.length){
                dadosEnvio.empresasOutliers = dadosEnvio.EmpresasOutliersSelecionadas
            }
            
            let urlName = !this.id ? 'CLUSTER_SALVAR' : 'CLUSTER_EDITAR';
            let method = !this.id ?  'POST' : 'PUT';

            let response = await this.axios({
                method: method,
                data: dadosEnvio,
                url: this.$urls[urlName]
            });

            this.loadingForm = false;

            if(response.status !== 200) {
                return;
            }

            this.$bvModal.hide('modal-cadastro-cluster')
            this.$parent.listarCluster();
        },
        async getListas() {

            const [marca, tipoDeEstabelecimento, localEstabelecimento, grupos] = await Promise.all([
                this.axios.get(this.$urls.CLUSTER_MARCAS),
                this.axios.get(this.$urls.CLUSTER_TIPO_ESTABELECIMENTO),
                this.axios.get(this.$urls.CLUSTER_LOCAL_ESTABELECIMENTO),
                this.axios.get(this.$urls.GRUPOS),
            ]);

            this.listas.marca = marca.data;
            this.listas.tipoDeEstabelecimento = tipoDeEstabelecimento.data;
            this.listas.localEstabelecimento = localEstabelecimento.data;
            this.listas.grupo = grupos.data;
        },
        async getListasLocalidades() {

            const [regiao, estado] = await Promise.all([
                this.axios.get(this.$urls.CLUSTER_REGIOES), 
                this.axios.get(this.$urls.CLUSTER_ESTADOS)
            ]);

            this.listas.regiao = regiao.data;
            this.listas.estado = estado.data;
        },
        async getEmpresas() {
            this.loadingEmpresas = true;
            
            let response = await this.axios.get(this.$urls.EMPRESAS);

            this.loadingEmpresas = false;

            if(response.status !== 200) {
                return;
            }

            this.listas.empresas = response.data
        },
        salvar() {
            const ctx = this;
            ctx.$refs['formCluster'].validate((valid) => {
                if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos obrigatórios`,
						position:'top-left'
					});
					return;
				}

                // salvar
                ctx.saveCluster();
            });
        },
        openModal() {
            const _this = this

            if(_this.id) {
                this.loadingForm = true
                if(!_this.listas.empresas.length) {
                    this.loadingEmpresas = true;

                    _this.axios.get(_this.$urls.EMPRESAS).then((response) => {
                        if(response.status !== 200) {
                            return;
                        }
                        
                        _this.listas.empresas = response.data
                        _this.loadingEmpresas = false;
                        _this.getCluster();
                    }).catch((err) => {
                        _this.loadingEmpresas = false;
                        _this.$notify.error({
                            title: 'Empresas',
                            message: `Ocorreu algum erro ao carregarmos as empresas`,
                            position:'top-left'
                        });
                    });
                }else{
                    _this.getCluster();
                }
                
                return
            }
            _this.model = model();
            _this.limparFiltros();

            if(localStorage.getItem('infoFiltros')) {
                _this.infoFiltros = false
            }
            
        },
        fecharModal() {
            this.model = model();
            this.limparFiltros();
            this.$refs['formCluster'].clearValidate();
        },
        limparFiltros() { // reset filtros
            this.filtros = filtros()
        },
        // filtrar e mostrar empresas
        filtrarEmpresas() {
            this.$bvModal.show('modal-filtro-empresas-cadastro')
        },
        paginacaoCurrent(val){
            this.paginacao.pageNumber = val

            this.requestEmpresas();
        },
        paginacaoSize(val){
            this.paginacao.perPage = val
        },
        fecharInfoFiltros() {
            localStorage.setItem('infoFiltros','visualizado')
            this.infoFiltros = false
        }
    },
    mounted() {
        const ctx = this;
        this.getListas();

        // listeners multiselect
        ctx.$root.$on('empresasASelectOptions',function(data){
            ctx.listas.empresas = data
        })

        ctx.$root.$on('empresasOutliersSelectOptions',function(data){
            ctx.listas.empresasOutliers = data
        })
    }
};
</script>
<style lang='scss' scoped>
.header-filter {
    padding: 1px 10px 2px 10px;
    .icon-close-filter {
        margin:3px;
    }
}
.box-filtro-info {
    border: 2px solid #c1c5c2;
    border-radius: 5px;
    padding: 0px 10px 2px;
    background: #e7e7e7;
}
.btn-filtros-a {
    margin-left: 5px;
}
#filtroEmpresas {
    padding: 21px !important;
}
</style>
